import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Alert, AlertIcon, Box, Button, Divider, Flex, FormControl, FormLabel, HStack, Input, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import { ColorSchemeSection, HeaderSection, SocialMediaSection } from './components/website';

import React from 'react';
import { useAppSelector } from '../../../hooks';
import { usePaystackPayment } from 'react-paystack';

export const WebsiteIntergrationView = () => {

    const { company } = useAppSelector(state => state.companyReducer);

    const { website, email } = company;

    const config: any = {
        // reference: ,
        email: email || '',
        amount: Number(`${100}00`),
        publicKey: process.env.REACT_APP_PAYSTACK_PUBLICK_KEY,
        currency: 'ZAR',
    };

    const initializePayment = usePaystackPayment(config);

    const _onClose = () => {
        console.log('');
    };

    //eslint-disable-next-line
    const handleDomainConfigurationPayment = async (values: any) => {
        //eslint-disable-next-line
        initializePayment((reference: void) => {
            // const data: any = reference;
            // donationForm.setFieldValue('reference', data?.reference);
            // dispatch(addDonation(values));
            // console.log(data?.reference);
        }, _onClose);
    };

    return (
        <>
            <Flex>
                <Stack bg={'#FFFFFF'} p={4} borderRadius={6} w={'full'}>
                    <HStack justifyContent={'space-between'}>
                        <Text fontSize={'xl'} fontWeight={'medium'}>Website CMS.</Text>
                        {/* <Button colorScheme={'green'} size={'sm'} rightIcon={<FiArrowRight />}>Add-On</Button> */}
                    </HStack>

                    <Divider />

                    <Accordion defaultIndex={[0, 1, 2, 3]} allowMultiple>

                        <AccordionItem boxShadow={'md'} borderRadius={4} border={'none'}>
                            <h2>
                                <AccordionButton bg={'gray.50'} minH={'50px'}>
                                    <Box as="span" flex='1' textAlign='left' fontWeight={'medium'}>
                                        Header section
                                    </Box>
                                    <AccordionIcon />
                                </AccordionButton>
                            </h2>
                            <AccordionPanel pb={4}>
                                <HeaderSection />
                            </AccordionPanel>
                        </AccordionItem>

                        <AccordionItem mt={6} boxShadow={'md'} borderRadius={4} border={'none'}>
                            <h2>
                                <AccordionButton bg={'gray.50'} minH={'50px'}>
                                    <Box as="span" flex='1' textAlign='left' fontWeight={'medium'}>
                                        Social media
                                    </Box>
                                    <AccordionIcon />
                                </AccordionButton>
                            </h2>
                            <AccordionPanel pb={4}>
                                <SocialMediaSection />
                            </AccordionPanel>
                        </AccordionItem>

                        <AccordionItem mt={6} boxShadow={'md'} borderRadius={4} border={'none'}>
                            <h2>
                                <AccordionButton bg={'gray.50'} minH={'50px'}>
                                    <Box as="span" flex='1' textAlign='left' fontWeight={'medium'}>
                                        UI - User Interface
                                    </Box>
                                    <AccordionIcon />
                                </AccordionButton>
                            </h2>
                            <AccordionPanel pb={4}>
                                <Alert status='info' mb={4} borderRadius={4}>
                                    <AlertIcon />
                                    Color scheme is your primary branding color, select the right one. It&apos;s for your website.
                                </Alert>
                                <ColorSchemeSection />
                            </AccordionPanel>
                        </AccordionItem>

                        <AccordionItem mt={6} boxShadow={'md'} borderRadius={4} border={'none'}>
                            <h2>
                                <AccordionButton bg={'gray.50'} minH={'50px'}>
                                    <Box as="span" flex='1' textAlign='left' fontWeight={'medium'}>
                                        Domains
                                    </Box>
                                    <AccordionIcon />
                                </AccordionButton>
                            </h2>
                            <AccordionPanel pb={4}>
                                <SimpleGrid columns={[1, 1, 2, 2]} spacing={3}>
                                    <FormControl isReadOnly>
                                        <FormLabel>Default domain</FormLabel>
                                        <Input name='default'
                                            value={website?.domains[0]?.domain}
                                            placeholder='https://default-domain.com'
                                            disabled
                                        />
                                    </FormControl>
                                    <FormControl isReadOnly>
                                        <FormLabel>Custom domain</FormLabel>
                                        <Input name='custom'
                                            value={website?.domains[1]?.domain}
                                            placeholder='https://custom-domain.com'
                                            disabled
                                        />
                                    </FormControl>
                                </SimpleGrid>
                                <Button my={3} float={'right'} colorScheme={'green'} onClick={handleDomainConfigurationPayment}>Request configuration - R100</Button>
                            </AccordionPanel>
                        </AccordionItem>
                    </Accordion>
                </Stack>
            </Flex >
        </>
    );
};